<div [ngClass]="tenantService.getDomainClass()" class="filter-container">
  <ion-icon (click)="isFilterVisible = true" class="filter filter-out"></ion-icon>
  <div *ngIf="isFilterVisible" class="overlay"></div>
  <div *ngIf="isFilterVisible" class="filter-items-container">
    <div class="filter-item header">
      <ion-icon [ngClass]="tenantService.getDomainClass()" class="filter"></ion-icon>
      <span>Filtres</span>
      <ion-icon (click)="onCloseFilter()" [ngClass]="tenantService.getDomainClass()" class="close-button"></ion-icon>
    </div>
    <div class="filter-item date">
      <span class="font-14">Date</span>
      <span class="date-value">{{ date | slice : 0 : 10 }}</span>
      <ion-list>
        <ion-icon  id="open-modal" datetime="datetime" [ngClass]="tenantService.getDomainClass()" class="calendar"></ion-icon>
        <ion-modal trigger="open-modal" [cssClass]="'center'">
          <ng-template>
            <ion-datetime presentation="date" [(ngModel)]="date" [locale]="configService.getLocale()" size="cover" [max]="maxDate"></ion-datetime>
          </ng-template>
        </ion-modal>
      </ion-list>
    </div>
    <div class="filter-item titre">
      <p>Journal</p>
      <select [(ngModel)]="selectedFilterJournal" (change)="onJournalChange($event)" name="titre" id="titre">
        <option value="">Choisir un journal</option>
        <ng-container  *ngFor="let journal of subscriptions">
          <option *ngIf="journal.subname !== 'play'" [value]="journal.subname">{{ journal.name }}</option>
        </ng-container>
      </select>
    </div>
    <div class="filter-item category" [class.disabled]="filterCategories.length === 1">
      <p>Categories</p>
      <select [(ngModel)]="selectedFilterCategory" [disabled]="filterCategories.length === 1" name="category" id="category">
        <option *ngFor="let cat of filterCategories" [value]="cat.category_slug">{{ cat.category_name }}</option>
      </select>
    </div>
    <div>
      <div (click)="onApplyFilter()" [class.disabled]="!(selectedFilterJournal.length || (selectedFilterCategory.length && date))"
        class="round-button cursor-pointer">Appliquer filtre(s)</div>
    </div>
  </div>
</div>